import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import ErrorImage from 'Shared/assets/images/404.svg';
import styles from './NoLevelResultsData.css';
const NoLevelResultsData = ({ message }) => (_jsxs("main", Object.assign({ className: styles.content }, { children: [_jsx("h1", Object.assign({ className: styles.primaryMessage, "data-testid": "primaryMessage" }, { children: message }), void 0), _jsx(ErrorImage, { className: styles.errorImage }, void 0)] }), void 0));
export default memo(NoLevelResultsData);
